import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit } from '@angular/core';
import { NavParams, ModalController, IonicModule } from '@ionic/angular';
import { Group, Zone, PositionCardModalResult, Level, PositionWithLevel } from 'src/app/model';
import { ApiService } from 'src/app/providers';
import { AccessStoreService } from 'src/app/store/access-store.service';

@Component({
  selector: 'app-position-card',
  templateUrl: './position-card.modal.html',
  styleUrls: ['./position-card.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PositionCardModalComponent implements OnInit {
  position: PositionWithLevel;
  group: Group;
  zone?: Zone;
  level: Level;

  loading = false;

  constructor(
    private acessState: AccessStoreService,
    private navParams: NavParams,
    private modalController: ModalController,
    private api: ApiService,
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.position = await this.navParams.get('position');
    const group = await this.api.groups.getGroupById(this.position.group_id);

    if (group) {
      this.group = group;

      const zone = await this.api.zones.getZoneById(this.group.zone_id);

      if (zone) {
        this.zone = zone;
      }

      if (group.level_id) {
        const level = await this.api.levels.getLevelById(group.level_id);

        if (level) {
          this.level = level;
        }
      }
    }

    this.loading = false;
  }

  public bind() {
    const result: PositionCardModalResult = {
      bind: true,
      additionalData: {
        zone: this.zone,
        group: this.group,
        level: this.level,
      },
    };
    this.modalController.dismiss(result);
  }

  public async edit() {
    const result: PositionCardModalResult = {
      edit: true,
      additionalData: {
        zone: this.zone,
        group: this.group,
        level: this.level,
      },
    };
    this.modalController.dismiss(result);
  }

  public access() {
    return this.acessState.writeaccess$;
  }

}
